var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetroEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 281,
    viewBox: "0 0 280 281",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.532 249.87C219.563 249.87 278.087 233.365 278.087 226.316V218.658C227.532 247.707 39.3095 247.707 2.75391 218.658V226.316C2.75391 233.365 67.5005 249.87 143.532 249.87Z",
    fill: "#F1DBC9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140.421 205.894C64.3894 205.894 2.75391 211.609 2.75391 218.658C39.3095 247.707 227.532 247.707 278.087 218.658C278.087 211.609 216.452 205.894 140.421 205.894Z",
    fill: "#F2D4BB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75391 218.658C2.75391 211.609 64.3894 205.894 140.421 205.894C216.452 205.894 278.087 211.609 278.087 218.658M2.75391 218.658V226.316C2.75391 233.365 67.5005 249.87 143.532 249.87C219.563 249.87 278.087 233.365 278.087 226.316V218.658M2.75391 218.658C39.3095 247.707 227.532 247.707 278.087 218.658",
    stroke: "#635A52",
    strokeWidth: 0.777778
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M139.255 237.394C213.353 237.394 273.421 224.459 273.421 216.502V207.857C233.795 224.134 181.48 225.344 139.255 225.344C97.0295 225.344 44.7144 224.134 5.08789 207.857V216.502C5.08789 224.459 65.1564 237.394 139.255 237.394Z",
    fill: "#F1DBC9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M139.255 193.449C65.1564 193.449 5.08789 199.9 5.08789 207.857C44.7144 224.134 97.0295 225.344 139.255 225.344C181.48 225.344 233.795 224.134 273.421 207.857C273.421 199.9 213.353 193.449 139.255 193.449Z",
    fill: "#F2D4BB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08789 207.857C5.08789 199.9 65.1564 193.449 139.255 193.449C213.353 193.449 273.421 199.9 273.421 207.857M5.08789 207.857V216.502C5.08789 224.459 65.1564 237.394 139.255 237.394C213.353 237.394 273.421 224.459 273.421 216.502V207.857M5.08789 207.857C44.7144 224.134 97.0295 225.344 139.255 225.344C181.48 225.344 233.795 224.134 273.421 207.857",
    stroke: "#635A52",
    strokeWidth: 0.777778
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M174.999 61.0887H104.677V42.234C104.677 40.8689 120.417 39.7603 139.838 39.7603C159.258 39.7603 174.999 40.8663 174.999 42.234V61.0861V61.0887Z",
    fill: "#BDBAA9",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M139.699 44.3501C138.825 44.3501 137.962 44.3501 137.103 44.3579V61.0872H139.699",
    fill: "#C5ECFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M139.699 44.3501C138.825 44.3501 137.962 44.3501 137.103 44.3579V61.0872H139.699",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M127.715 44.5007V61.0875H131.987V44.4126C130.528 44.4359 129.098 44.4644 127.715 44.5007Z",
    fill: "#C5ECFF",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M119.255 44.8151V61.0859H122.736V44.6597C121.53 44.7063 120.367 44.7581 119.255 44.8151Z",
    fill: "#C5ECFF",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M111.024 45.3998V61.0852H114.051V45.1382C112.96 45.2211 111.949 45.3092 111.024 45.3998Z",
    fill: "#C5ECFF",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M139.699 43.5674C138.825 43.5674 137.961 43.5674 137.102 43.5752C136.741 43.5752 136.38 43.5803 136.019 43.5829V61.0894H137.102V44.3601C137.958 44.3549 138.825 44.3523 139.699 44.3523",
    fill: "#A67C52"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M139.699 43.5674C138.825 43.5674 137.961 43.5674 137.102 43.5752C136.741 43.5752 136.38 43.5803 136.019 43.5829V61.0894H137.102V44.3601C137.958 44.3549 138.825 44.3523 139.699 44.3523",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M127.715 43.7142C127.18 43.7271 126.653 43.7427 126.133 43.7582V61.0885H127.715V44.5017C129.101 44.4654 130.528 44.4369 131.987 44.4136V61.0885H132.622V43.6157C132.409 43.6183 132.196 43.6209 131.987 43.6261C130.528 43.6494 129.098 43.6779 127.715 43.7142Z",
    fill: "#A67C52",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M117.448 44.1289V61.0887H119.258V44.8153C120.37 44.7584 121.533 44.7065 122.739 44.6599V43.875C121.533 43.9216 120.37 43.9734 119.258 44.0304C118.64 44.0615 118.037 44.0952 117.448 44.1289Z",
    fill: "#A67C52",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M108.674 44.8872V61.088H111.025V45.4001C111.949 45.3068 112.96 45.2187 114.051 45.1384V44.3535C112.96 44.4364 111.949 44.5245 111.025 44.6152C110.162 44.7006 109.374 44.7913 108.674 44.8872Z",
    fill: "#A67C52",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M104.676 44.4208V61.0879H105.972V43.7524C105.127 43.9649 104.676 44.1876 104.676 44.4182V44.4208Z",
    fill: "#BDBAA9",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M114.049 45.1402V61.0898H115.443V41.9229C114.966 41.9539 114.5 41.9876 114.049 42.0239V45.1428V45.1402Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M105.971 46.1502V61.0869H106.668V42.8784C106.411 42.9302 106.18 42.982 105.971 43.0338V46.1528V46.1502Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M122.734 44.6601V61.0863H124.489V41.479C123.894 41.4997 123.309 41.5205 122.734 41.5438V44.6627V44.6601Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M132.625 41.2844V61.086H135.102V41.2559C134.268 41.2636 133.441 41.274 132.625 41.2844Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M115.442 45.0376V61.0856H117.447V41.7969C116.757 41.8357 116.089 41.8798 115.442 41.9212V45.0402V45.0376Z",
    fill: "#BDBAA9",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M106.668 45.9978V61.0899H108.672V42.5576C107.899 42.6612 107.228 42.77 106.668 42.8814V46.0004V45.9978Z",
    fill: "#BDBAA9",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M124.488 44.5985V61.0895H126.131V41.4277C125.575 41.4433 125.03 41.4614 124.488 41.4795V44.5985Z",
    fill: "#BDBAA9",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M135.103 41.2553V61.0854H136.023V41.2476C135.716 41.2476 135.41 41.2527 135.103 41.2553Z",
    fill: "#BDBAA9",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M114.05 42.8017L115.444 42.4414L117.448 42.5762V41.7984L115.444 41.6636L114.05 42.024V42.8017Z",
    fill: "#382456",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M122.734 42.3206L124.489 41.9965L126.133 42.204V41.4262L124.489 41.2188L122.734 41.5428V42.3206Z",
    fill: "#382456",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M132.626 42.0617L135.103 41.8957L136.024 42.0254V41.1283L135.103 40.9961L132.626 41.1646V42.0617Z",
    fill: "#382456",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M105.972 43.8125L106.669 43.3976L108.673 43.3354V42.5576L106.669 42.6198L105.972 43.0347V43.8125Z",
    fill: "#382456",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M105.972 44.3224L104.676 44.4779V43.7004L105.972 43.5449V44.3224Z",
    fill: "#382456",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M139.699 44.3506C140.573 44.3506 141.436 44.3506 142.296 44.3584V61.0877H139.699",
    fill: "#C5ECFF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M139.699 44.3506C140.573 44.3506 141.436 44.3506 142.296 44.3584V61.0877H139.699",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M151.689 44.5012V61.088H147.417V44.4131C148.876 44.4364 150.306 44.4649 151.689 44.5012Z",
    fill: "#C5ECFF",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M160.144 44.8146V61.0854H156.663V44.6592C157.869 44.7058 159.032 44.7576 160.144 44.8146Z",
    fill: "#C5ECFF",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M168.379 45.4003V61.0857H165.353V45.1387C166.443 45.2216 167.454 45.3096 168.379 45.4003Z",
    fill: "#C5ECFF",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M139.699 43.5679C140.573 43.5679 141.436 43.5679 142.296 43.5756C142.657 43.5756 143.018 43.5808 143.379 43.5834V61.0899H142.296V44.3606C141.44 44.3554 140.573 44.3528 139.699 44.3528",
    fill: "#A67C52"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M139.699 43.5679C140.573 43.5679 141.436 43.5679 142.296 43.5756C142.657 43.5756 143.018 43.5808 143.379 43.5834V61.0899H142.296V44.3606C141.44 44.3554 140.573 44.3528 139.699 44.3528",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M151.687 43.7151C152.222 43.7281 152.749 43.7436 153.269 43.7592V61.0895H151.687V44.5026C150.3 44.4664 148.874 44.4379 147.415 44.4146V61.0895H146.779V43.6167C146.992 43.6193 147.205 43.6219 147.415 43.6271C148.874 43.6504 150.304 43.6789 151.687 43.7151Z",
    fill: "#A67C52",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M161.954 44.1294V61.0892H160.144V44.8158C159.032 44.7588 157.869 44.707 156.663 44.6604V43.8755C157.869 43.9221 159.032 43.9739 160.144 44.0309C160.762 44.062 161.365 44.0957 161.954 44.1294Z",
    fill: "#A67C52",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M170.73 44.8876V61.0885H168.379V45.4006C167.454 45.3073 166.443 45.2192 165.353 45.1389V44.354C166.443 44.4369 167.454 44.525 168.379 44.6156C169.242 44.7011 170.029 44.7918 170.73 44.8876Z",
    fill: "#A67C52",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M174.723 44.4208V61.0879H173.427V43.7524C174.272 43.9649 174.723 44.1876 174.723 44.4182V44.4208Z",
    fill: "#BDBAA9",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M165.352 45.1402V61.0898H163.958V41.9229C164.435 41.9539 164.901 41.9876 165.352 42.0239V45.1428V45.1402Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M173.426 46.1502V61.0869H172.729V42.8784C172.986 42.9302 173.217 42.982 173.426 43.0338V46.1528V46.1502Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M156.667 44.6606V61.0868H154.912V41.4795C155.508 41.5002 156.093 41.5209 156.667 41.5443V44.6632V44.6606Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M146.777 41.2848V61.0865H144.3V41.2563C145.134 41.2641 145.961 41.2745 146.777 41.2848Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M163.958 45.0376V61.0856H161.954V41.7969C162.644 41.8357 163.312 41.8798 163.958 41.9212V45.0402V45.0376Z",
    fill: "#BDBAA9",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M172.73 45.9973V61.0894H170.726V42.5571C171.498 42.6607 172.17 42.7695 172.73 42.8809V45.9999V45.9973Z",
    fill: "#BDBAA9",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M154.91 44.5985V61.0895H153.267V41.4277C153.823 41.4433 154.368 41.4614 154.91 41.4795V44.5985Z",
    fill: "#BDBAA9",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M144.3 41.2558V61.0859H143.379V41.248C143.686 41.248 143.993 41.2532 144.3 41.2558Z",
    fill: "#BDBAA9",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M165.352 42.8017L163.958 42.4414L161.954 42.5762V41.7984L163.958 41.6636L165.352 42.024V42.8017Z",
    fill: "#382456",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M156.668 42.3206L154.909 41.9965L153.27 42.204V41.4262L154.909 41.2188L156.668 41.5428V42.3206Z",
    fill: "#382456",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M146.777 42.0617L144.3 41.8957L143.379 42.0254V41.1283L144.3 40.9961L146.777 41.1646V42.0617Z",
    fill: "#382456",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M173.428 43.8125L172.731 43.3976L170.73 43.3354V42.5576L172.731 42.6198L173.428 43.0347V43.8125Z",
    fill: "#382456",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M173.427 44.3229L174.723 44.4784V43.7009L173.427 43.5454V44.3229Z",
    fill: "#382456",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M139.838 57.3232C130.42 57.3232 104.677 59.2064 104.677 60.574V64.2523H174.999V60.574C174.999 59.209 149.255 57.3232 139.838 57.3232Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M174.999 41.1446C174.999 39.7795 159.258 38.6709 139.838 38.6709C120.417 38.6709 104.677 39.7769 104.677 41.1446V42.2325C104.677 40.8675 120.417 39.7588 139.838 39.7588C159.258 39.7588 174.999 40.8649 174.999 42.2325V41.1446Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6533 67.3082L72.293 69.5308L139.701 63.8445V60.9761L69.6533 67.3082Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M72.293 69.5306V76.0431L139.701 70.3532V63.8442L72.293 69.5306Z",
    fill: "#DA7263",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2998 78.4887L47.42 82.1581L139.701 75.025V70.3525L43.2998 78.4887Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4199 82.1581V95.4754L139.701 87.9815V75.0249L47.4199 82.1581Z",
    fill: "#DA7263",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4199 105.762L139.701 95.0213V87.9819L47.4199 95.4759V105.762Z",
    fill: "#DDDAD0",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1338 62.5406V64.7415L139.701 60.9747V58.7773L97.1338 62.5406Z",
    fill: "#DA7263",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5771 61.4951L97.1335 62.5414L139.701 58.7782V57.353L95.5771 61.4951Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M209.748 67.3082L207.112 69.5308L139.7 63.8445V60.9761L209.748 67.3082Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M207.112 69.5306V76.0431L139.7 70.3532V63.8442L207.112 69.5306Z",
    fill: "#DA7263",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M236.101 78.4887L231.985 82.1581L139.7 75.025V70.3525L236.101 78.4887Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M231.985 82.1581V95.4754L139.7 87.9815V75.0249L231.985 82.1581Z",
    fill: "#DA7263",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M231.985 105.762L139.7 95.0213V87.9819L231.985 95.4759V105.762Z",
    fill: "#DDDAD0",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M182.268 62.5406V64.7415L139.7 60.9747V58.7773L182.268 62.5406Z",
    fill: "#DA7263",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M183.828 61.4951L182.268 62.5414L139.7 58.7782V57.353L183.828 61.4951Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.996 124.629V121.759C254.677 121.714 230.077 120.834 201.042 117.165C147.349 110.382 148.938 94.3008 148.938 94.3008H130.978C130.978 94.3008 132.571 110.378 78.8749 117.165C49.4997 120.877 24.665 121.734 8.35156 121.761V124.628C24.4301 124.651 48.9758 123.856 78.8713 120.225C132.597 113.687 130.975 98.2444 130.975 98.2444H148.935C148.935 98.2444 147.313 113.687 201.038 120.225C230.589 123.814 254.911 124.632 270.996 124.629Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.96 127.483C255.108 127.531 231.06 126.786 201.092 123.285C147.366 116.992 149.016 102.185 149.016 102.185H131.065C131.065 102.185 132.715 116.992 78.9885 123.285C48.5084 126.846 24.1902 127.575 8.35156 127.5V130.377C23.9723 130.5 48.0316 129.829 78.9885 126.348C132.744 120.304 131.065 106.132 131.065 106.132H149.016C149.016 106.132 147.337 120.304 201.092 126.348C231.522 129.77 255.323 130.458 270.96 130.364V127.483Z",
    fill: "#BDBAA9",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.941 124.632C254.859 124.633 230.57 123.811 201.069 120.227C147.357 113.69 148.979 98.2471 148.979 98.2471H131.024C131.024 98.2471 132.645 113.69 78.9336 120.227C48.9945 123.864 24.4238 124.656 8.35156 124.631V127.501C24.196 127.574 48.4924 126.843 78.9336 123.287C132.674 116.995 131.024 102.187 131.024 102.187H148.979C148.979 102.187 147.329 116.995 201.069 123.287C231.059 126.79 255.086 127.553 270.941 127.506V124.632Z",
    fill: "#DDDAD0",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.91 98.1111C150.929 89.044 156.586 67.8105 156.586 67.8105H123.417C123.417 67.8105 129.075 89.044 73.093 98.1111C47.0163 102.333 18.9479 102.968 0.779297 102.806L5.58552 108.409C23.1284 108.374 49.6392 107.484 75.0425 103.368C131.024 94.301 127.201 75.8132 127.201 75.8132H152.806C152.806 75.8132 148.983 94.2974 204.965 103.368C230.366 107.484 256.875 108.372 274.418 108.405L279.224 102.803C261.055 102.964 232.989 102.329 206.914 98.1075L206.91 98.1111Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.345 108.403C256.802 108.368 230.331 107.476 204.964 103.368C148.983 94.3008 152.806 76.2842 152.806 76.2842H127.201C127.201 76.2842 131.024 94.2972 75.0421 103.368C49.6741 107.478 23.2016 108.369 5.6582 108.404L8.4245 112.249C24.605 112.181 49.4052 111.277 78.9337 107.546C132.613 100.763 131.024 80.1587 131.024 80.1587H148.979C148.979 80.1587 147.386 100.763 201.069 107.546C230.267 111.236 254.843 112.16 271.032 112.247L274.345 108.403Z",
    fill: "#DDDAD0",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.962 112.245C254.763 112.157 230.201 111.23 201.024 107.545C147.318 100.762 148.908 80.1577 148.908 80.1577H130.943C130.943 80.1577 132.537 100.762 78.8271 107.545C49.327 111.271 24.5437 112.177 8.35352 112.248V121.756C24.6719 121.728 49.4864 120.868 78.8307 117.161C132.537 110.377 130.947 94.2963 130.947 94.2963H148.912C148.912 94.2963 147.318 110.374 201.028 117.161C230.048 120.827 254.638 121.708 270.962 121.755V112.245Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M208.445 206.667H253.872V203.899H208.445V206.667Z",
    fill: "#603813",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M158.566 206.667H186.905V203.899H158.566V206.667Z",
    fill: "#603813",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M270.953 136.706H262.886V206.67H270.953V136.706Z",
    fill: "#603813",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M211.698 140.892V153.317L215.597 153.612V135.899L211.698 140.892Z",
    fill: "#6B3232",
    stroke: "#382456",
    strokeWidth: 0.418056
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M215.855 206.67H212.133V156.147L215.855 153.49V206.67Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.485362
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M212.133 156.313L185.079 154.94V151.61L215.929 153.673L212.133 156.313Z",
    fill: "#6B3232",
    stroke: "#382456",
    strokeWidth: 0.485362
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M185.147 151.609V131.938C185.617 131.938 215.93 135.651 215.93 135.651V153.49C215.93 153.49 185.711 151.609 185.147 151.609Z",
    fill: "#DA7263",
    stroke: "#382456",
    strokeWidth: 0.418056
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M233.514 187.075C234.554 187.085 235.544 187.096 236.475 187.107V195.648H230.553V187.039C231.578 187.053 232.568 187.064 233.514 187.075Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M239.436 187.141C240.559 187.152 241.552 187.159 242.397 187.166V195.649H236.475V187.108C237.54 187.119 238.529 187.13 239.436 187.137V187.141Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M227.596 187.003C228.611 187.017 229.6 187.028 230.557 187.039V195.648H224.635V186.959C225.646 186.974 226.632 186.988 227.596 186.999V187.003Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M221.673 186.92C222.677 186.934 223.666 186.949 224.634 186.963V195.652H218.661V186.876C219.68 186.891 220.683 186.905 221.673 186.92Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M236.475 178.6C237.526 178.621 238.515 178.639 239.436 178.654V187.141C238.53 187.133 237.54 187.123 236.475 187.112C235.543 187.101 234.554 187.09 233.514 187.079V178.542C234.547 178.564 235.536 178.585 236.475 178.603V178.6Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M242.396 178.697V187.166C241.551 187.159 240.558 187.151 239.435 187.141V178.654C240.518 178.672 241.511 178.686 242.396 178.697Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M230.556 178.47C231.578 178.495 232.564 178.517 233.517 178.538V187.076C232.571 187.065 231.582 187.054 230.556 187.04C229.599 187.029 228.61 187.014 227.595 187.004V178.394C228.606 178.419 229.595 178.445 230.556 178.47Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M221.673 186.921C220.683 186.906 219.68 186.892 218.661 186.877V178.134C219.68 178.167 220.683 178.199 221.673 178.228V186.921Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M224.633 178.315C225.641 178.344 226.63 178.369 227.594 178.394V187.004C226.63 186.993 225.644 186.979 224.633 186.964C223.665 186.95 222.676 186.935 221.672 186.921V178.229C222.676 178.257 223.662 178.286 224.633 178.315Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M227.596 169.83C228.604 169.869 229.59 169.905 230.557 169.938V178.472C229.597 178.45 228.611 178.425 227.596 178.396C226.632 178.371 225.642 178.342 224.635 178.317V169.707C225.639 169.75 226.625 169.79 227.596 169.83Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M233.514 170.034C234.532 170.067 235.522 170.092 236.475 170.117V178.601C235.536 178.583 234.547 178.561 233.514 178.539C232.561 178.518 231.575 178.496 230.553 178.471V169.937C231.564 169.973 232.553 170.006 233.514 170.034Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M239.436 170.186C240.48 170.207 241.465 170.222 242.397 170.233V178.698C241.516 178.687 240.523 178.673 239.436 178.655C238.515 178.64 237.526 178.622 236.475 178.6V170.117C237.504 170.142 238.49 170.164 239.436 170.186Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M221.673 169.572C222.673 169.618 223.659 169.662 224.634 169.705V178.315C223.663 178.286 222.677 178.257 221.673 178.228C220.683 178.199 219.68 178.167 218.661 178.134V169.427C219.676 169.478 220.68 169.528 221.673 169.572Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M239.435 170.186V159.234C240.478 159.256 241.464 159.27 242.396 159.281V170.233C241.468 170.222 240.478 170.207 239.435 170.186Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M221.673 158.626V169.577C220.68 169.53 219.676 169.483 218.661 169.433V158.481C219.676 158.532 220.68 158.582 221.673 158.626Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M224.635 158.754C225.639 158.797 226.625 158.837 227.596 158.877V169.828C226.625 169.792 225.639 169.749 224.635 169.705C223.664 169.662 222.674 169.619 221.674 169.572V158.621C222.674 158.668 223.66 158.711 224.635 158.754Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M236.475 159.167C237.504 159.192 238.49 159.214 239.436 159.236V170.187C238.494 170.169 237.504 170.147 236.475 170.118C235.522 170.093 234.532 170.068 233.514 170.035V159.084C234.532 159.116 235.522 159.142 236.475 159.167Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M230.556 158.986C231.567 159.022 232.557 159.055 233.517 159.084V170.035C232.557 170.006 231.567 169.974 230.556 169.937C229.588 169.905 228.602 169.869 227.595 169.829V158.878C228.602 158.918 229.588 158.954 230.556 158.986Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M172.863 185.722C173.488 185.751 174.134 185.78 174.806 185.809V195.649H170.92V185.625C171.537 185.657 172.188 185.69 172.863 185.722Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M168.977 185.512C169.587 185.548 170.234 185.588 170.92 185.624V195.648H167.034V185.379C167.626 185.426 168.276 185.469 168.977 185.512Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M176.744 185.889C177.733 185.929 178.762 185.965 179.824 186.001V195.65H174.801V185.81C175.429 185.835 176.079 185.864 176.744 185.889Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M165.091 185.207C165.643 185.264 166.293 185.322 167.034 185.38V195.649H163.332V184.936C163.686 185.03 164.282 185.12 165.091 185.207Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M174.801 175.821C175.433 175.879 176.08 175.937 176.744 175.991V185.889C176.08 185.863 175.43 185.835 174.801 185.809C174.133 185.78 173.483 185.752 172.858 185.723V175.634C173.487 175.695 174.133 175.76 174.801 175.821Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M170.919 175.433C171.541 175.502 172.194 175.57 172.862 175.639V185.728C172.187 185.695 171.537 185.663 170.919 185.63C170.237 185.594 169.587 185.558 168.977 185.518V175.202C169.594 175.282 170.241 175.357 170.919 175.433Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M167.034 174.935C167.64 175.025 168.29 175.115 168.977 175.202V185.518C168.276 185.475 167.626 185.432 167.034 185.385C166.293 185.327 165.643 185.269 165.091 185.211V174.614C165.679 174.722 166.326 174.83 167.034 174.939V174.935Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M176.744 175.99C177.741 176.073 178.766 176.156 179.825 176.235V185.999C178.763 185.963 177.734 185.923 176.744 185.887V175.99Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M165.091 185.207C164.282 185.12 163.682 185.03 163.332 184.936V174.223C163.83 174.353 164.423 174.483 165.091 174.606V185.203V185.207Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M165.091 163.947C165.708 164.088 166.358 164.228 167.034 164.366V174.938C166.326 174.833 165.679 174.725 165.091 174.613C164.423 174.487 163.83 174.361 163.332 174.231V163.518C163.888 163.662 164.477 163.806 165.091 163.947Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M168.977 164.738C169.605 164.854 170.252 164.965 170.92 165.077V175.433C170.241 175.357 169.595 175.282 168.977 175.202C168.291 175.116 167.641 175.025 167.034 174.935V164.363C167.659 164.489 168.305 164.615 168.977 164.734V164.738Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M172.863 165.388C173.498 165.485 174.145 165.582 174.806 165.676V175.823C174.138 175.762 173.491 175.7 172.863 175.635C172.195 175.567 171.541 175.502 170.92 175.43V165.074C171.552 165.178 172.198 165.283 172.863 165.384V165.388Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M176.744 165.945C177.748 166.079 178.773 166.212 179.824 166.339V176.24C178.766 176.16 177.737 176.077 176.744 175.994C176.079 175.937 175.433 175.883 174.801 175.825V165.678C175.436 165.768 176.086 165.859 176.744 165.945Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M176.744 154.995C177.748 155.129 178.774 155.262 179.825 155.388V166.34C178.774 166.213 177.748 166.08 176.744 165.946V154.995Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M165.091 152.997V163.949C164.477 163.808 163.885 163.664 163.332 163.519V152.568C163.888 152.712 164.477 152.857 165.091 152.997Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M174.801 154.726C175.437 154.816 176.087 154.906 176.744 154.993V165.944C176.087 165.857 175.437 165.767 174.801 165.677C174.14 165.583 173.494 165.486 172.858 165.388V154.437C173.494 154.534 174.14 154.632 174.801 154.726Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M167.034 153.416C167.658 153.542 168.305 153.669 168.977 153.788V164.739C168.305 164.616 167.658 164.494 167.034 164.367C166.358 164.23 165.708 164.093 165.091 163.949V152.998C165.708 153.138 166.358 153.279 167.034 153.416Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M170.919 154.127C171.551 154.231 172.198 154.336 172.862 154.437V165.388C172.198 165.287 171.551 165.183 170.919 165.078C170.255 164.966 169.605 164.854 168.977 164.739V153.788C169.605 153.903 170.251 154.015 170.919 154.127Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M242.397 156.056V159.278C236.42 159.21 227.96 158.943 218.661 158.477V139.001C226.439 139.571 234.358 139.903 242.397 140.026V156.056Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M245.312 137.334V195.648H242.394V140.026C234.356 139.903 226.436 139.571 218.658 139.001V136.273C227.375 136.912 236.266 137.255 245.308 137.334H245.312Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M186.902 124.407C191.095 125.114 195.739 125.771 200.899 126.348C203.463 126.637 205.976 126.904 208.446 127.153C211.949 127.506 215.354 127.827 218.662 128.112C228.433 128.957 237.338 129.512 245.311 129.866C248.298 129.996 251.15 130.1 253.873 130.18V203.907H215.748V135.858C208.429 135.103 192.27 133.367 185.239 132.118L184.709 203.911H158.562V116.285C164.196 119.125 173.032 122.069 186.902 124.414V124.407ZM218.662 158.478V195.648H245.311V137.335C236.269 137.252 227.379 136.912 218.662 136.274V158.478ZM163.333 152.568V195.652H179.828V131.028C174.224 129.873 168.724 128.545 163.333 127.023V152.564V152.568Z",
    fill: "#DA7263",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M270.955 139.836H262.888V133.2L270.955 132.202V139.836Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M270.979 130.387V132.267L253.871 134.226V130.181L270.979 130.387Z",
    fill: "#6B3232",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M178.874 155.27C172.62 154.487 167.203 153.585 163.332 152.564V128.105C168.416 129.541 173.602 130.797 178.874 131.904V155.27Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M178.874 130.821C179.192 130.889 179.506 130.958 179.827 131.026V195.65H178.874V131.907C173.602 130.799 168.413 129.543 163.332 128.107V127.025C168.416 128.461 173.602 129.717 178.874 130.824V130.821Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M245.311 195.647V137.334C236.269 137.251 227.378 136.912 218.661 136.273",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M244.339 195.647V138.229C235.633 138.131 227.064 137.796 218.661 137.179",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M243.368 195.647V139.127C234.994 139.019 226.754 138.683 218.661 138.091",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M242.397 195.647V140.025C234.358 139.903 226.439 139.571 218.661 139",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M158.562 116.278H139.7V106.131H148.7C148.7 106.131 148.125 111.021 158.562 116.278Z",
    fill: "#6B3232",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M158.562 116.281H148.411V203.903H158.562V116.281Z",
    fill: "#A7584B"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M158.563 203.903H148.411V206.671H158.563V203.903Z",
    fill: "#603813",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M139.701 116.278H130.995V206.671H139.701H148.411V116.278H139.701Z",
    fill: "#603813",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M139.702 106.127H130.995V116.278H139.702H148.413V106.127H139.702Z",
    fill: "#DA7263",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71191 130.386V132.266L25.8192 134.226V130.181L8.71191 130.386Z",
    fill: "#6B3232",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2447 206.667H25.8174V203.899H71.2447V206.667Z",
    fill: "#603813",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M121.125 206.667H92.7852V203.899H121.125V206.667Z",
    fill: "#603813",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73561 136.706H16.8027V206.67H8.73561V136.706Z",
    fill: "#603813",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9922 140.892V153.317L64.0933 153.612V135.899L67.9922 140.892Z",
    fill: "#6B3232",
    stroke: "#382456",
    strokeWidth: 0.418056
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8355 206.671H68.0225V154.877L63.8355 151.606V206.671Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.485362
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9925 154.787H94.6006V151.343L64.1913 151.833L67.9925 154.787Z",
    fill: "#6B3232",
    stroke: "#382456",
    strokeWidth: 0.485362
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5439 151.079V131.938C94.0745 131.938 63.7616 135.651 63.7616 135.651V151.609L94.5439 151.079Z",
    fill: "#DA7263",
    stroke: "#382456",
    strokeWidth: 0.418056
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1764 187.075C45.1363 187.085 44.1468 187.096 43.2151 187.107V195.648H49.1377V187.039C48.1121 187.053 47.1226 187.064 46.1764 187.075Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2545 187.141C39.1314 187.152 38.1383 187.159 37.2932 187.166V195.649H43.2158V187.108C42.1505 187.119 41.161 187.13 40.2545 187.137V187.141Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0944 187.003C51.0796 187.017 50.0901 187.028 49.1331 187.039V195.648H55.0557V186.959C54.0445 186.974 53.0586 186.988 52.0944 186.999V187.003Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0174 186.92C57.0135 186.934 56.024 186.949 55.0561 186.963V195.652H61.0293V186.876C60.0109 186.891 59.0069 186.905 58.0174 186.92Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2155 178.6C42.1646 178.621 41.175 178.639 40.2541 178.654V187.141C41.1606 187.133 42.1501 187.123 43.2155 187.112C44.1472 187.101 45.1367 187.09 46.1768 187.079V178.542C45.1439 178.564 44.1544 178.585 43.2155 178.603V178.6Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2926 178.697V187.166C38.1377 187.159 39.1308 187.151 40.2539 187.141V178.654C39.1705 178.672 38.1774 178.686 37.2926 178.697Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1344 178.47C48.1124 178.495 47.1265 178.517 46.1731 178.538V187.076C47.1193 187.065 48.1088 187.054 49.1344 187.04C50.0914 187.029 51.0809 187.014 52.0957 187.004V178.394C51.0845 178.419 50.095 178.445 49.1344 178.47Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0174 186.921C59.0069 186.906 60.0109 186.892 61.0293 186.877V178.134C60.0109 178.167 59.0069 178.199 58.0174 178.228V186.921Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0572 178.315C54.0497 178.344 53.0602 178.369 52.0959 178.394V187.004C53.0602 186.993 54.0461 186.979 55.0572 186.964C56.0251 186.95 57.0146 186.935 58.0186 186.921V178.229C57.0146 178.257 56.0287 178.286 55.0572 178.315Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0944 169.83C51.0868 169.869 50.1009 169.905 49.1331 169.938V178.472C50.0937 178.45 51.0796 178.425 52.0944 178.396C53.0586 178.371 54.0481 178.342 55.0557 178.317V169.707C54.0517 169.75 53.0658 169.79 52.0944 169.83Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1764 170.034C45.158 170.067 44.1685 170.092 43.2151 170.117V178.601C44.1541 178.583 45.1436 178.561 46.1764 178.539C47.1298 178.518 48.1157 178.496 49.1377 178.471V169.937C48.1265 169.973 47.137 170.006 46.1764 170.034Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2545 170.186C39.2108 170.207 38.2249 170.222 37.2932 170.233V178.698C38.1744 178.687 39.1675 178.673 40.2545 178.655C41.1754 178.64 42.1649 178.622 43.2158 178.6V170.117C42.1866 170.142 41.2007 170.164 40.2545 170.186Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0174 169.572C57.0171 169.618 56.0312 169.662 55.0561 169.705V178.315C56.0276 178.286 57.0135 178.257 58.0174 178.228C59.0069 178.199 60.0109 178.167 61.0293 178.134V169.427C60.0145 169.478 59.0105 169.528 58.0174 169.572Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2539 170.186V159.234C39.2102 159.256 38.2243 159.27 37.2926 159.281V170.233C38.2207 170.222 39.2102 170.207 40.2539 170.186Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0174 158.626V169.577C59.0105 169.53 60.0145 169.483 61.0293 169.433V158.481C60.0145 158.532 59.0105 158.582 58.0174 158.626Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0553 158.754C54.0513 158.797 53.0654 158.837 52.094 158.877V169.828C53.0654 169.792 54.0513 169.749 55.0553 169.705C56.0267 169.662 57.0163 169.619 58.0166 169.572V158.621C57.0163 158.668 56.0304 158.711 55.0553 158.754Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2155 159.167C42.1862 159.192 41.2003 159.214 40.2541 159.236V170.187C41.1967 170.169 42.1862 170.147 43.2155 170.118C44.1688 170.093 45.1584 170.068 46.1768 170.035V159.084C45.1584 159.116 44.1688 159.142 43.2155 159.167Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1344 158.986C48.1232 159.022 47.1337 159.055 46.1731 159.084V170.035C47.1337 170.006 48.1232 169.974 49.1344 169.937C50.1023 169.905 51.0881 169.869 52.0957 169.829V158.878C51.0881 158.918 50.1023 158.954 49.1344 158.986Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M106.83 185.722C106.205 185.751 105.558 185.78 104.887 185.809V195.649H108.772V185.625C108.155 185.657 107.505 185.69 106.83 185.722Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M110.715 185.512C110.105 185.548 109.459 185.588 108.772 185.624V195.648H112.658V185.379C112.066 185.426 111.416 185.469 110.715 185.512Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M102.947 185.889C101.957 185.929 100.928 185.965 99.8663 186.001V195.65H104.89V185.81C104.261 185.835 103.611 185.864 102.947 185.889Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M114.6 185.207C114.047 185.264 113.397 185.322 112.657 185.38V195.649H116.358V184.936C116.004 185.03 115.409 185.12 114.6 185.207Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M104.889 175.821C104.257 175.879 103.611 175.937 102.946 175.991V185.889C103.611 185.863 104.261 185.835 104.889 185.809C105.557 185.78 106.207 185.752 106.832 185.723V175.634C106.204 175.695 105.557 175.76 104.889 175.821Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M108.771 175.434C108.15 175.502 107.496 175.571 106.828 175.639V185.728C107.503 185.696 108.153 185.663 108.771 185.631C109.454 185.595 110.104 185.559 110.714 185.519V175.203C110.096 175.282 109.45 175.358 108.771 175.434Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M112.657 174.935C112.05 175.025 111.4 175.115 110.714 175.202V185.518C111.414 185.475 112.064 185.432 112.657 185.385C113.397 185.327 114.047 185.269 114.6 185.211V174.614C114.011 174.722 113.365 174.83 112.657 174.939V174.935Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M102.946 175.99C101.95 176.073 100.924 176.156 99.8658 176.236V186C100.928 185.964 101.957 185.924 102.946 185.888V175.99Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M114.6 185.207C115.409 185.12 116.008 185.03 116.358 184.936V174.223C115.86 174.353 115.268 174.483 114.6 174.606V185.203V185.207Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M114.6 163.947C113.982 164.088 113.332 164.228 112.657 164.366V174.938C113.365 174.833 114.011 174.725 114.6 174.613C115.268 174.487 115.86 174.361 116.358 174.231V163.518C115.802 163.662 115.214 163.806 114.6 163.947Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M110.715 164.738C110.087 164.854 109.44 164.965 108.772 165.077V175.433C109.451 175.357 110.098 175.282 110.715 175.202C111.401 175.116 112.051 175.025 112.658 174.935V164.363C112.033 164.489 111.387 164.615 110.715 164.734V164.738Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M106.83 165.388C106.194 165.485 105.548 165.582 104.887 165.676V175.823C105.555 175.762 106.201 175.7 106.83 175.635C107.498 175.567 108.151 175.502 108.772 175.43V165.074C108.14 165.178 107.494 165.283 106.83 165.384V165.388Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M102.947 165.945C101.943 166.079 100.917 166.212 99.8663 166.339V176.24C100.924 176.16 101.954 176.077 102.947 175.994C103.611 175.937 104.258 175.883 104.89 175.825V165.678C104.254 165.768 103.604 165.859 102.947 165.945Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M102.946 154.996C101.942 155.129 100.917 155.263 99.8658 155.389V166.34C100.917 166.214 101.942 166.08 102.946 165.947V154.996Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M114.6 152.997V163.949C115.214 163.808 115.806 163.664 116.358 163.519V152.568C115.802 152.712 115.214 152.857 114.6 152.997Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M104.889 154.726C104.254 154.816 103.603 154.906 102.946 154.993V165.944C103.603 165.857 104.254 165.767 104.889 165.677C105.55 165.583 106.196 165.486 106.832 165.388V154.437C106.196 154.534 105.55 154.632 104.889 154.726Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M112.657 153.416C112.032 153.542 111.386 153.669 110.714 153.788V164.739C111.386 164.616 112.032 164.494 112.657 164.367C113.332 164.23 113.982 164.093 114.6 163.949V152.998C113.982 153.138 113.332 153.279 112.657 153.416Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M108.771 154.127C108.139 154.231 107.493 154.336 106.828 154.437V165.388C107.493 165.287 108.139 165.183 108.771 165.078C109.435 164.966 110.085 164.854 110.714 164.739V153.788C110.085 153.903 109.439 154.015 108.771 154.127Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2937 156.056V159.278C43.27 159.209 51.7308 158.942 61.0293 158.477V139C53.251 139.571 45.3319 139.903 37.2937 140.025V156.056Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3789 137.334V195.647H37.2966V140.025C45.3349 139.903 53.254 139.571 61.0322 139.001V136.273C52.3151 136.912 43.4246 137.254 34.3825 137.334H34.3789Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7882 124.406C88.5958 125.114 83.9519 125.77 78.7917 126.348C76.2278 126.636 73.7145 126.903 71.2446 127.152C67.7418 127.506 64.3366 127.827 61.0289 128.112C51.2573 128.956 42.3524 129.512 34.3791 129.865C31.3928 129.995 28.54 130.1 25.8173 130.179V203.907H63.9422V135.857C71.2619 135.103 87.4203 133.366 94.4511 132.118L94.5991 203.91H121.128V116.285C115.495 119.124 106.658 122.068 92.7882 124.414V124.406ZM61.0289 158.477V195.648H34.3791V137.334C43.4213 137.251 52.3117 136.912 61.0289 136.273V158.477ZM116.358 152.567V195.651H99.8623V131.027C105.467 129.873 110.966 128.545 116.358 127.022V152.564V152.567Z",
    fill: "#DA7263",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M8.735 139.836H16.8027V133.2L8.735 132.202V139.836Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M100.816 155.27C107.071 154.487 112.487 153.585 116.358 152.564V128.105C111.274 129.541 106.089 130.797 100.816 131.904V155.27Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M100.816 130.821C100.499 130.889 100.184 130.958 99.863 131.026V195.65H100.816V131.907C106.089 130.799 111.278 129.543 116.358 128.107V127.025C111.274 128.461 106.089 129.717 100.816 130.824V130.821Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3796 195.647V137.334C43.4217 137.251 52.3122 136.912 61.0293 136.273",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3509 195.647V138.229C44.0572 138.131 52.6263 137.796 61.0293 137.179",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3223 195.647V139.127C44.6964 139.019 52.9369 138.683 61.0293 138.091",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2937 195.647V140.025C45.3319 139.903 53.251 139.571 61.0293 139",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M121.127 116.278H139.989V106.131H130.99C130.99 106.131 131.564 111.021 121.127 116.278Z",
    fill: "#6B3232",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M21.889 135.889H21.3906V131.764H21.889V135.889Z",
    fill: "#382456",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2568 137.242H21.0186V135.885H22.2568V137.242Z",
    fill: "#382456",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6399 142.92C19.9805 142.92 18.6352 141.576 18.6352 139.918C18.6352 138.26 19.9805 136.916 21.6399 136.916C23.2993 136.916 24.6445 138.26 24.6445 139.918C24.6445 141.576 23.2993 142.92 21.6399 142.92Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M121.129 116.281H131.279V203.903H121.129V116.281Z",
    fill: "#A7584B"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M121.128 203.903H131.279V206.671H121.128V203.903Z",
    fill: "#603813",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M139.989 116.278H148.695V206.671H139.989H131.279V116.278H139.989Z",
    fill: "#603813",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M139.988 106.127H148.695V116.278H139.988H131.278V106.127H139.988Z",
    fill: "#DA7263",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0633 154.319H94.1433V206.658H68.0633V154.319Z",
    fill: "url(#paint0_linear_6004_59250)",
    stroke: "#453D3D",
    strokeWidth: 0.474183,
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6857 189.848L61.05 191.666V201.87L66.6857 199.688V189.848Z",
    fill: "url(#paint1_linear_6004_59250)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6857 157.693L61.05 156.238V171.368L66.6857 170.641V157.693Z",
    fill: "url(#paint2_linear_6004_59250)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9031 151.456L68.2959 154.365L68.5642 154.728V206.722L58.9031 210.722V151.456ZM61.05 156.238L66.6857 157.693V170.641L61.05 171.368V156.238ZM66.6857 189.848L61.05 191.666V201.87L66.6857 199.688V189.848Z",
    fill: "#E1AE81"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9031 151.456V210.722L58.098 210.358V151.82L58.9031 151.456Z",
    fill: "#946A47"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6857 173.091L61.05 174.182V188.757L66.6857 186.939V173.091Z",
    fill: "url(#paint3_linear_6004_59250)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5771 206.691L58.9749 210.722L57.9969 210.336V203.816L58.9749 204.113L68.5771 200.319V206.691Z",
    fill: "#B3B3B3"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9857 178.906C60.2767 178.906 60.5127 179.242 60.5127 179.656V188.44C60.5127 188.854 60.2767 189.19 59.9857 189.19C59.6946 189.19 59.4587 188.854 59.4587 188.44V179.656C59.4587 179.242 59.6946 178.906 59.9857 178.906Z",
    fill: "#644F3D"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8815 178.906C57.5904 178.906 57.3545 179.242 57.3545 179.656V188.44C57.3545 188.854 57.5904 189.19 57.8815 189.19V178.906Z",
    fill: "#644F3D"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9031 151.456L68.2959 154.365L68.5642 154.728V206.722L58.9031 210.722M58.9031 151.456V210.722M58.9031 151.456L58.098 151.82V210.358L58.9031 210.722M66.6857 189.848L61.05 191.666V201.87L66.6857 199.688V189.848ZM66.6857 157.693L61.05 156.238V171.368L66.6857 170.641V157.693ZM66.6857 173.091L61.05 174.182V188.757L66.6857 186.939V173.091ZM68.5771 206.691L58.9749 210.722L57.9969 210.336V203.816L58.9749 204.113L68.5771 200.319V206.691ZM59.9857 178.906C60.2767 178.906 60.5127 179.242 60.5127 179.656V188.44C60.5127 188.854 60.2767 189.19 59.9857 189.19C59.6946 189.19 59.4587 188.854 59.4587 188.44V179.656C59.4587 179.242 59.6946 178.906 59.9857 178.906ZM57.8815 178.906C57.5904 178.906 57.3545 179.242 57.3545 179.656V188.44C57.3545 188.854 57.5904 189.19 57.8815 189.19V178.906Z",
    stroke: "#453D3D",
    strokeWidth: 0.474183
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8582 189.848L100.494 191.666V201.87L94.8582 199.688V189.848Z",
    fill: "url(#paint4_linear_6004_59250)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8582 189.848L100.494 191.666V201.87L94.8582 199.688V189.848Z",
    fill: "url(#paint5_linear_6004_59250)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8582 157.693L100.494 156.238V171.368L94.8582 170.641V157.693Z",
    fill: "url(#paint6_linear_6004_59250)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8582 157.693L100.494 156.238V171.368L94.8582 170.641V157.693Z",
    fill: "url(#paint7_linear_6004_59250)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.641 151.456L93.248 154.365L92.9797 154.728V206.722L102.641 210.722V151.456ZM100.494 156.238L94.8582 157.693V170.641L100.494 171.368V156.238ZM94.8582 189.848L100.494 191.666V201.87L94.8582 199.688V189.848Z",
    fill: "#E1AE81"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M102.641 151.456V210.722L103.446 210.358V151.82L102.641 151.456Z",
    fill: "#946A47"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8582 173.091L100.494 174.182V188.757L94.8582 186.939V173.091Z",
    fill: "url(#paint8_linear_6004_59250)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8582 173.091L100.494 174.182V188.757L94.8582 186.939V173.091Z",
    fill: "url(#paint9_linear_6004_59250)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9668 206.691L102.569 210.721L103.547 210.336V203.816L102.569 204.113L92.9668 200.319V206.691Z",
    fill: "#B3B3B3"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.558 178.906C101.267 178.906 101.031 179.242 101.031 179.656V188.44C101.031 188.854 101.267 189.19 101.558 189.19C101.849 189.19 102.085 188.854 102.085 188.44V179.656C102.085 179.242 101.849 178.906 101.558 178.906Z",
    fill: "#644F3D"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.672 178.817C103.963 178.817 104.199 179.153 104.199 179.568V188.351C104.199 188.765 103.963 189.101 103.672 189.101V178.817Z",
    fill: "#644F3D"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M102.641 151.456L93.248 154.365L92.9797 154.728V206.722L102.641 210.722M102.641 151.456V210.722M102.641 151.456L103.446 151.82V210.358L102.641 210.722M94.8582 189.848L100.494 191.666V201.87L94.8582 199.688V189.848ZM94.8582 157.693L100.494 156.238V171.368L94.8582 170.641V157.693ZM94.8582 173.091L100.494 174.182V188.757L94.8582 186.939V173.091ZM92.9668 206.691L102.569 210.721L103.547 210.336V203.816L102.569 204.113L92.9668 200.319V206.691ZM101.558 178.906C101.267 178.906 101.031 179.242 101.031 179.656V188.44C101.031 188.854 101.267 189.19 101.558 189.19C101.849 189.19 102.085 188.854 102.085 188.44V179.656C102.085 179.242 101.849 178.906 101.558 178.906ZM103.672 178.817C103.963 178.817 104.199 179.153 104.199 179.568V188.351C104.199 188.765 103.963 189.101 103.672 189.101V178.817Z",
    stroke: "#453D3D",
    strokeWidth: 0.474183
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M271.245 130.386V132.266L254.138 134.226V130.181L271.245 130.386Z",
    fill: "#6B3232",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M208.712 206.667H254.14V203.899H208.712V206.667Z",
    fill: "#603813",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M158.832 206.667H187.172V203.899H158.832V206.667Z",
    fill: "#603813",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M271.221 136.706H263.154V206.67H271.221V136.706Z",
    fill: "#603813",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M211.967 140.892V153.317L215.866 153.612V135.899L211.967 140.892Z",
    fill: "#6B3232",
    stroke: "#382456",
    strokeWidth: 0.418056
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M216.124 206.671H211.937V154.877L216.124 151.606V206.671Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.485362
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M211.967 154.787H185.358V151.343L215.768 151.833L211.967 154.787Z",
    fill: "#6B3232",
    stroke: "#382456",
    strokeWidth: 0.485362
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M185.414 151.079V131.938C185.884 131.938 216.196 135.651 216.196 135.651V151.609L185.414 151.079Z",
    fill: "#DA7263",
    stroke: "#382456",
    strokeWidth: 0.418056
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M233.782 187.075C234.822 187.085 235.811 187.096 236.743 187.107V195.648H230.82V187.039C231.846 187.053 232.835 187.064 233.782 187.075Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M239.703 187.141C240.826 187.152 241.819 187.159 242.664 187.166V195.649H236.741V187.108C237.807 187.119 238.796 187.13 239.703 187.137V187.141Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M227.862 187.003C228.876 187.017 229.866 187.028 230.823 187.039V195.648H224.9V186.959C225.912 186.974 226.897 186.988 227.862 186.999V187.003Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M221.941 186.92C222.945 186.934 223.934 186.949 224.902 186.963V195.652H218.929V186.876C219.947 186.891 220.951 186.905 221.941 186.92Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M236.743 178.6C237.793 178.621 238.783 178.639 239.704 178.654V187.141C238.797 187.133 237.808 187.123 236.743 187.112C235.811 187.101 234.821 187.09 233.781 187.079V178.542C234.814 178.564 235.804 178.585 236.743 178.603V178.6Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M242.663 178.697V187.166C241.818 187.159 240.825 187.151 239.702 187.141V178.654C240.786 178.672 241.779 178.686 242.663 178.697Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M230.824 178.47C231.846 178.495 232.832 178.517 233.785 178.538V187.076C232.839 187.065 231.849 187.054 230.824 187.04C229.867 187.029 228.877 187.014 227.862 187.004V178.394C228.873 178.419 229.863 178.445 230.824 178.47Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M221.941 186.921C220.951 186.906 219.947 186.892 218.929 186.877V178.134C219.947 178.167 220.951 178.199 221.941 178.228V186.921Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M224.901 178.315C225.908 178.344 226.898 178.369 227.862 178.394V187.004C226.898 186.993 225.912 186.979 224.901 186.964C223.933 186.95 222.943 186.935 221.939 186.921V178.229C222.943 178.257 223.929 178.286 224.901 178.315Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M227.862 169.829C228.869 169.868 229.855 169.905 230.823 169.937V178.471C229.862 178.449 228.876 178.424 227.862 178.395C226.897 178.37 225.908 178.341 224.9 178.316V169.706C225.904 169.749 226.89 169.789 227.862 169.829Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M233.782 170.034C234.8 170.067 235.79 170.092 236.743 170.117V178.601C235.804 178.583 234.814 178.561 233.782 178.539C232.828 178.518 231.842 178.496 230.82 178.471V169.937C231.831 169.973 232.821 170.006 233.782 170.034Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M239.703 170.186C240.746 170.207 241.732 170.222 242.664 170.233V178.698C241.783 178.687 240.79 178.673 239.703 178.655C238.782 178.64 237.792 178.622 236.741 178.6V170.117C237.77 170.142 238.756 170.164 239.703 170.186Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M221.941 169.572C222.941 169.618 223.927 169.662 224.902 169.705V178.315C223.93 178.286 222.945 178.257 221.941 178.228C220.951 178.199 219.947 178.167 218.929 178.134V169.427C219.943 169.478 220.947 169.528 221.941 169.572Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M239.702 170.186V159.234C240.746 159.256 241.732 159.27 242.663 159.281V170.233C241.735 170.222 240.746 170.207 239.702 170.186Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M221.941 158.626V169.577C220.947 169.53 219.943 169.483 218.929 169.433V158.481C219.943 158.532 220.947 158.582 221.941 158.626Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M224.901 158.754C225.905 158.797 226.891 158.837 227.862 158.877V169.828C226.891 169.792 225.905 169.749 224.901 169.705C223.929 169.662 222.94 169.619 221.939 169.572V158.621C222.94 158.668 223.926 158.711 224.901 158.754Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M236.743 159.167C237.772 159.192 238.758 159.214 239.704 159.236V170.187C238.761 170.169 237.772 170.147 236.743 170.118C235.789 170.093 234.8 170.068 233.781 170.035V159.084C234.8 159.116 235.789 159.142 236.743 159.167Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M230.824 158.986C231.835 159.022 232.824 159.055 233.785 159.084V170.035C232.824 170.006 231.835 169.974 230.824 169.937C229.856 169.905 228.87 169.869 227.862 169.829V158.878C228.87 158.918 229.856 158.954 230.824 158.986Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M173.127 185.722C173.752 185.751 174.399 185.78 175.07 185.809V195.649H171.185V185.625C171.802 185.657 172.452 185.69 173.127 185.722Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M169.242 185.512C169.852 185.548 170.498 185.588 171.185 185.624V195.648H167.299V185.379C167.891 185.426 168.541 185.469 169.242 185.512Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M177.01 185.889C178 185.929 179.029 185.965 180.091 186.001V195.65H175.067V185.81C175.696 185.835 176.346 185.864 177.01 185.889Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M165.357 185.207C165.91 185.264 166.56 185.322 167.3 185.38V195.649H163.599V184.936C163.953 185.03 164.548 185.12 165.357 185.207Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M175.068 175.821C175.7 175.879 176.346 175.937 177.011 175.991V185.889C176.346 185.863 175.696 185.835 175.068 185.809C174.4 185.78 173.75 185.752 173.125 185.723V175.634C173.753 175.695 174.4 175.76 175.068 175.821Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M171.186 175.433C171.807 175.502 172.461 175.57 173.129 175.639V185.728C172.454 185.695 171.804 185.663 171.186 185.63C170.504 185.594 169.853 185.558 169.243 185.518V175.202C169.861 175.282 170.507 175.357 171.186 175.433Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M167.3 174.935C167.907 175.025 168.557 175.115 169.243 175.202V185.518C168.543 185.475 167.893 185.432 167.3 185.385C166.56 185.327 165.91 185.269 165.357 185.211V174.614C165.946 174.722 166.593 174.83 167.3 174.939V174.935Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M177.011 175.99C178.007 176.073 179.033 176.156 180.091 176.235V185.999C179.029 185.963 178 185.923 177.011 185.887V175.99Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M165.357 185.207C164.548 185.12 163.949 185.03 163.599 184.936V174.223C164.097 174.353 164.689 174.483 165.357 174.606V185.203V185.207Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M165.357 163.947C165.975 164.088 166.625 164.228 167.3 164.366V174.938C166.592 174.833 165.946 174.725 165.357 174.613C164.689 174.487 164.097 174.361 163.599 174.231V163.518C164.155 163.662 164.743 163.806 165.357 163.947Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M169.242 164.738C169.87 164.854 170.517 164.965 171.185 165.077V175.433C170.506 175.357 169.859 175.282 169.242 175.202C168.556 175.116 167.906 175.025 167.299 174.935V164.363C167.924 164.489 168.57 164.615 169.242 164.734V164.738Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M173.127 165.388C173.763 165.485 174.41 165.582 175.07 165.676V175.823C174.402 175.762 173.756 175.7 173.127 175.635C172.459 175.567 171.806 175.502 171.185 175.43V165.074C171.817 165.178 172.463 165.283 173.127 165.384V165.388Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M177.01 165.945C178.014 166.079 179.04 166.212 180.091 166.339V176.24C179.033 176.16 178.003 176.077 177.01 175.994C176.346 175.937 175.699 175.883 175.067 175.825V165.678C175.703 165.768 176.353 165.859 177.01 165.945Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M177.011 154.995C178.015 155.129 179.04 155.262 180.091 155.388V166.34C179.04 166.213 178.015 166.08 177.011 165.946V154.995Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M165.357 152.997V163.949C164.743 163.808 164.151 163.664 163.599 163.519V152.568C164.155 152.712 164.743 152.857 165.357 152.997Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M175.068 154.726C175.704 154.816 176.354 154.906 177.011 154.993V165.944C176.354 165.857 175.704 165.767 175.068 165.677C174.407 165.583 173.761 165.486 173.125 165.388V154.437C173.761 154.534 174.407 154.632 175.068 154.726Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M167.3 153.416C167.925 153.542 168.572 153.669 169.243 153.788V164.739C168.572 164.616 167.925 164.494 167.3 164.367C166.625 164.23 165.975 164.093 165.357 163.949V152.998C165.975 153.138 166.625 153.279 167.3 153.416Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M171.186 154.127C171.818 154.231 172.464 154.336 173.129 154.437V165.388C172.464 165.287 171.818 165.183 171.186 165.078C170.522 164.966 169.872 164.854 169.243 164.739V153.788C169.872 153.903 170.518 154.015 171.186 154.127Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M242.662 156.056V159.278C236.686 159.21 228.225 158.943 218.927 158.477V139.001C226.705 139.571 234.624 139.903 242.662 140.026V156.056Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M245.577 137.334V195.648H242.659V140.026C234.621 139.903 226.702 139.571 218.924 139.001V136.273C227.641 136.912 236.531 137.255 245.574 137.334H245.577Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M187.168 124.407C191.36 125.114 196.004 125.771 201.164 126.348C203.728 126.637 206.242 126.904 208.711 127.153C212.214 127.506 215.619 127.827 218.927 128.112C228.699 128.957 237.604 129.512 245.577 129.866C248.563 129.996 251.416 130.1 254.139 130.18V203.907H216.014V135.858C208.694 135.103 192.536 133.367 185.505 132.118L185.62 203.911H158.828V116.285C164.461 119.125 173.298 122.069 187.168 124.414V124.407ZM218.927 158.478V195.648H245.577V137.335C236.535 137.252 227.644 136.912 218.927 136.274V158.478ZM163.598 152.568V195.652H180.094V131.028C174.489 129.873 168.99 128.545 163.598 127.023V152.564V152.568Z",
    fill: "#DA7263",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M271.222 139.836H263.154V133.2L271.222 132.202V139.836Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M179.141 155.27C172.886 154.487 167.47 153.585 163.599 152.564V128.105C168.683 129.541 173.869 130.797 179.141 131.904V155.27Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M179.141 130.821C179.458 130.889 179.773 130.958 180.094 131.026V195.65H179.141V131.907C173.869 130.799 168.679 129.543 163.599 128.107V127.025C168.683 128.461 173.869 129.717 179.141 130.824V130.821Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M245.578 195.647V137.334C236.536 137.251 227.646 136.912 218.929 136.273",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M244.607 195.647V138.229C235.901 138.131 227.332 137.796 218.929 137.179",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M243.636 195.647V139.127C235.262 139.019 227.021 138.683 218.929 138.091",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M242.664 195.647V140.025C234.626 139.903 226.707 139.571 218.929 139",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M158.832 116.278H139.97V106.131H148.969C148.969 106.131 148.395 111.021 158.832 116.278Z",
    fill: "#6B3232",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M257.715 135.889H258.213V131.764H257.715V135.889Z",
    fill: "#382456",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M257.348 137.242H258.586V135.885H257.348V137.242Z",
    fill: "#382456",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M257.965 142.92C259.624 142.92 260.969 141.576 260.969 139.918C260.969 138.26 259.624 136.916 257.965 136.916C256.305 136.916 254.96 138.26 254.96 139.918C254.96 141.576 256.305 142.92 257.965 142.92Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M158.828 116.281H148.678V203.903H158.828V116.281Z",
    fill: "#A7584B"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M158.829 203.903H148.678V206.671H158.829V203.903Z",
    fill: "#603813",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M139.968 116.278H131.262V206.671H139.968H148.678V116.278H139.968Z",
    fill: "#603813",
    stroke: "#382456",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M139.969 106.127H131.262V116.278H139.969H148.679V106.127H139.969Z",
    fill: "#DA7263",
    stroke: "#382456",
    strokeWidth: 0.361134
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M212.377 154.732H199.11V206.815H212.377V154.732Z",
    fill: "#E1AE81",
    stroke: "#453D3D",
    strokeWidth: 0.386933,
    strokeLinejoin: "round"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M210.515 158.57H201.986V172.73H210.515V158.57Z",
    fill: "url(#paint10_linear_6004_59250)",
    stroke: "#453D3D",
    strokeWidth: 0.386933,
    strokeLinejoin: "round"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M210.515 174.35H201.986V188.51H210.515V174.35Z",
    fill: "url(#paint11_linear_6004_59250)",
    stroke: "#453D3D",
    strokeWidth: 0.386933,
    strokeLinejoin: "round"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M210.515 190.502H201.986V199.363H210.515V190.502Z",
    fill: "url(#paint12_linear_6004_59250)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M210.515 190.502H201.986V199.363H210.515V190.502Z",
    fill: "url(#paint13_linear_6004_59250)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M210.515 190.502H201.986V199.363H210.515V190.502Z",
    stroke: "#453D3D",
    strokeWidth: 0.386933,
    strokeLinejoin: "round"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.728 179.286C201.019 179.286 201.254 179.614 201.254 180.019V187.819C201.254 188.224 201.019 188.552 200.728 188.552C200.437 188.552 200.201 188.224 200.201 187.819V180.019C200.201 179.614 200.437 179.286 200.728 179.286Z",
    fill: "#644F3D",
    stroke: "#453D3D",
    strokeWidth: 0.278267
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M209.979 201.003H202.296H199.226V206.815H202.296H209.979H212.377V201.003H209.979Z",
    fill: "#B3B3B3",
    stroke: "#453D3D",
    strokeWidth: 0.386933,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M199.11 154.732H185.844V206.815H199.11V154.732Z",
    fill: "#E1AE81",
    stroke: "#453D3D",
    strokeWidth: 0.386933,
    strokeLinejoin: "round"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M196.259 158.57H187.73V172.73H196.259V158.57Z",
    fill: "url(#paint14_linear_6004_59250)",
    stroke: "#453D3D",
    strokeWidth: 0.386933,
    strokeLinejoin: "round"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M196.259 174.35H187.73V188.51H196.259V174.35Z",
    fill: "url(#paint15_linear_6004_59250)",
    stroke: "#453D3D",
    strokeWidth: 0.386933,
    strokeLinejoin: "round"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M196.259 190.502H187.73V199.363H196.259V190.502Z",
    fill: "url(#paint16_linear_6004_59250)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M196.259 190.502H187.73V199.363H196.259V190.502Z",
    fill: "url(#paint17_linear_6004_59250)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M196.259 190.502H187.73V199.363H196.259V190.502Z",
    stroke: "#453D3D",
    strokeWidth: 0.386933,
    strokeLinejoin: "round"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.493 179.286C197.784 179.286 198.02 179.618 198.02 180.029V187.808C198.02 188.219 197.784 188.552 197.493 188.552C197.203 188.552 196.967 188.219 196.967 187.808V180.029C196.967 179.618 197.203 179.286 197.493 179.286Z",
    fill: "#644F3D",
    stroke: "#453D3D",
    strokeWidth: 0.278267
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M195.963 201.003H188.541H186.051V206.815H188.541H195.963H198.99V201.003H195.963Z",
    fill: "#B3B3B3",
    stroke: "#453D3D",
    strokeWidth: 0.386933,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.638 53.2544H129.695C133.122 60.4996 136.556 67.7392 140 74.9788C143.45 67.7392 146.9 60.4996 150.333 53.2544H150.39C155.499 66.1034 160.621 78.9467 165.759 91.7843C166.988 91.8013 168.212 91.8069 169.441 91.8013V95.0107H148.214V91.8013C149.619 91.8013 151.018 91.8013 152.423 91.7843C150.803 87.7428 149.189 83.6957 147.58 79.6429C145.047 84.7542 142.526 89.8768 140.028 95.005H139.972C137.473 89.8824 134.975 84.7598 132.477 79.6429C130.828 83.6844 129.197 87.7315 127.576 91.7843C128.981 91.8013 130.381 91.8069 131.786 91.8013V95.0107H110.559V91.8013C111.788 91.8013 113.012 91.8013 114.241 91.7843C119.385 78.9467 124.517 66.1034 129.638 53.2544Z",
    fill: "#F00C50",
    stroke: "#382456",
    strokeWidth: 0.422632,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M118.862 97.6299V105.366L118.161 105.922L118.862 106.174L119.627 105.72H119.653V105.705L122.737 103.876V95.2592L121.996 95.0571L118.858 97.6335L118.862 97.6299ZM121.91 103.54L119.656 104.893V97.9582L121.91 96.5907V103.544V103.54Z",
    fill: "#6B3232",
    stroke: "#6B3232",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M118.161 97.4208V105.918L118.92 105.464H118.945V105.449L121.996 103.624V95.0537L118.161 97.4208ZM121.177 103.295L118.945 104.645V97.7455L121.177 96.3816V103.299V103.295Z",
    fill: "#AD5750",
    stroke: "#AD5750",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M102.157 104.157V109.851L101.774 112.019L102.157 112.373L102.937 112.149V110.46L107.321 109.447V102.558L106.903 102.223L102.157 104.16V104.157ZM106.484 108.819L102.941 109.663V104.712L106.484 103.637V108.819Z",
    fill: "#6B3232",
    stroke: "#6B3232",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M101.774 103.829V112.02L102.547 111.796V110.111L106.903 109.086V102.22L101.774 103.829ZM106.068 108.466L102.547 109.317V104.381L106.068 103.302V108.466Z",
    fill: "#AD5750",
    stroke: "#AD5750",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0751 108.379V109.183L80.6201 115.606L81.0751 115.938H81.8805V109.075L83.6898 108.833L83.2347 115.202L83.6898 115.534H84.4951V108.725L86.3008 108.483L85.8493 114.798L86.3008 115.13H87.1097V108.375V107.567L86.6583 107.235L81.0751 108.379Z",
    fill: "#6B3232",
    stroke: "#6B3232",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6201 108.043V108.848V115.606H81.4291V108.74L83.2347 108.498V115.202H84.0437V108.39L85.8493 108.148V114.798H86.6583V108.04V107.235L80.6201 108.043Z",
    fill: "#AD5750",
    stroke: "#AD5750",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1031 111.156V110.352L62.6084 110.153L56.6533 110.922V111.727V114.299V115.104L56.1621 118.287L56.6533 118.481L63.1031 117.911V117.107L62.6084 116.908L57.4622 117.641V115.068L63.1031 114.534V113.729L62.6084 113.531L57.4622 114.263V111.69L63.1031 111.156Z",
    fill: "#6B3232",
    stroke: "#6B3232",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6084 110.958V110.153L56.1621 110.723V111.528V114.101V114.905V117.478V118.287L62.6084 117.716V116.908L56.9674 117.442V114.869L62.6084 114.335V113.531L56.9674 114.065V111.492L62.6084 110.958Z",
    fill: "#AD5750",
    stroke: "#AD5750",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1351 112.044L33.2858 118.345L30.3534 112.304L29.5625 112.34L29.5697 120.52L30.3751 120.488L30.3606 113.986L32.8886 119.221L33.6939 119.189L36.1532 113.729L36.2363 120.246L37.0452 120.214L36.9296 112.008L36.1351 112.044Z",
    fill: "#6B3232",
    stroke: "#6B3232",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6335 112.066L32.7805 118.367L29.859 112.326L29.0645 112.362V120.539L29.8698 120.506L29.859 114.011L32.3869 119.243L33.1886 119.211L35.6552 113.751L35.731 120.268L36.5399 120.236L36.4316 112.03L35.6335 112.066Z",
    fill: "#AD5750",
    stroke: "#AD5750",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M256.67 113.121L256.157 113.099L249.881 112.388L249.411 112.792V120.464L250.216 120.5L256.157 120.77L256.67 120.792L257.436 120.402L256.966 113.135L256.67 113.121ZM250.216 119.695V113.637L256.157 113.907V119.966L250.216 119.695Z",
    fill: "#6B3232",
    stroke: "#6B3232",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M257.139 112.717L256.626 112.695L250.685 112.424L249.88 112.388V120.06L250.685 120.096L256.626 120.366L257.139 120.388L257.435 120.402V112.731L257.139 112.717ZM250.685 119.291V113.233L256.626 113.503V119.562L250.685 119.291Z",
    fill: "#AD5750",
    stroke: "#AD5750",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M223.408 111.043L223.021 110.559L222.603 110.956V118.876L223.408 118.909L223.827 118.512L223.408 117.296L229.479 117.96L229.897 117.563L229.479 117.126V111.707L223.408 111.043ZM228.67 117.04L223.404 116.466V111.876L228.67 112.45V117.04Z",
    fill: "#6B3232",
    stroke: "#6B3232",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M223.021 110.559V118.479L223.826 118.512V116.899L229.897 117.563V111.31L223.021 110.559ZM229.091 116.643L223.826 116.069V111.479L229.091 112.053V116.643Z",
    fill: "#AD5750",
    stroke: "#AD5750",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M197.728 108.18V109.003V116.007L198.547 116.151L198.912 115.787L198.547 109.115L200.418 109.364V116.458L201.227 116.599L201.588 116.238L201.227 109.472L203.069 109.718V116.902L203.863 117.039L204.217 116.682L203.863 109.826V109.018L198.096 107.823L197.728 108.18Z",
    fill: "#6B3232",
    stroke: "#6B3232",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M198.097 107.823V108.646V115.643L198.913 115.787V108.758L200.784 109.01V116.097L201.589 116.238V109.119L203.423 109.368V116.541L204.218 116.682V109.476V108.668L198.097 107.823Z",
    fill: "#AD5750",
    stroke: "#AD5750",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M180.808 105.384L181.418 105.063L180.808 104.576L176.395 103.05L175.788 103.367V104.176V107.181V107.986V110.995V111.8L180.808 113.009L181.418 112.691L180.808 112.204L176.593 111.19V108.181L180.808 109.195L181.418 108.877L180.808 108.39L176.593 107.376V104.367L180.808 105.384Z",
    fill: "#6B3232",
    stroke: "#6B3232",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M181.417 105.063V104.259L176.394 103.05V103.854V106.86V107.668V110.674V111.482L181.417 112.691V111.883L177.199 110.869V107.863L181.417 108.877V108.069L177.199 107.055V104.049L181.417 105.063Z",
    fill: "#AD5750",
    stroke: "#AD5750",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M161.759 98.2415L160.39 104.083L159.13 96.4121L158.985 95.8022L158.324 95.943V104.816L159.13 105.242L159.79 105.101L159.13 99.9338L160.04 105.682L160.621 105.909L161.282 105.772L161.759 100.977V106.833L162.564 107.067L163.225 106.927L162.564 98.5735L162.419 98.1044L161.759 98.2415Z",
    fill: "#6B3232",
    stroke: "#6B3232",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M162.42 98.1044L161.051 103.943L159.791 96.2713L158.985 95.8022V104.675L159.791 105.101V99.7967L160.701 105.545L161.282 105.772L162.42 100.836V106.692L163.225 106.927V98.4327L162.42 98.1044Z",
    fill: "#AD5750",
    stroke: "#AD5750",
    strokeWidth: 0.361134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6615 148.699V142.807H71.4054C72.0899 142.807 72.623 142.939 73.0046 143.203C73.3861 143.467 73.5769 143.843 73.5769 144.331C73.5769 144.813 73.3973 145.189 73.0382 145.459C72.6791 145.722 72.2022 145.854 71.6074 145.854L71.7673 145.501C72.4294 145.501 72.9428 145.633 73.3076 145.896C73.6723 146.16 73.8547 146.542 73.8547 147.041C73.8547 147.557 73.6583 147.964 73.2655 148.262C72.8783 148.553 72.3116 148.699 71.5653 148.699H68.6615ZM70.0166 147.689H71.5148C71.829 147.689 72.0675 147.627 72.2302 147.504C72.3929 147.381 72.4743 147.19 72.4743 146.932C72.4743 146.685 72.3929 146.502 72.2302 146.385C72.0675 146.261 71.829 146.199 71.5148 146.199H70.0166V147.689ZM70.0166 145.248H71.2875C71.5849 145.248 71.8094 145.189 71.9609 145.072C72.1124 144.948 72.1881 144.769 72.1881 144.533C72.1881 144.297 72.1124 144.12 71.9609 144.003C71.8094 143.879 71.5849 143.817 71.2875 143.817H70.0166V145.248ZM74.226 148.699L76.2544 146.039L76.2292 146.763L74.2849 144.171H75.7578L76.9867 145.863L76.4312 145.88L77.7021 144.171H79.0993L77.1466 146.738V146.031L79.1667 148.699H77.6769L76.3891 146.898L76.9362 146.974L75.6568 148.699H74.226ZM81.7944 148.767C81.3118 148.767 80.8825 148.666 80.5066 148.464C80.1362 148.262 79.8417 147.987 79.6228 147.639C79.4096 147.285 79.303 146.884 79.303 146.435C79.303 145.981 79.4096 145.579 79.6228 145.231C79.8417 144.878 80.1362 144.603 80.5066 144.407C80.8825 144.205 81.3118 144.104 81.7944 144.104C82.2713 144.104 82.6978 144.205 83.0737 144.407C83.4497 144.603 83.7443 144.875 83.9575 145.223C84.1707 145.571 84.2773 145.975 84.2773 146.435C84.2773 146.884 84.1707 147.285 83.9575 147.639C83.7443 147.987 83.4497 148.262 83.0737 148.464C82.6978 148.666 82.2713 148.767 81.7944 148.767ZM81.7944 147.689C82.0132 147.689 82.2096 147.639 82.3835 147.538C82.5575 147.437 82.695 147.294 82.796 147.108C82.897 146.918 82.9475 146.693 82.9475 146.435C82.9475 146.171 82.897 145.947 82.796 145.762C82.695 145.577 82.5575 145.433 82.3835 145.332C82.2096 145.231 82.0132 145.181 81.7944 145.181C81.5755 145.181 81.3791 145.231 81.2052 145.332C81.0312 145.433 80.891 145.577 80.7843 145.762C80.6833 145.947 80.6328 146.171 80.6328 146.435C80.6328 146.693 80.6833 146.918 80.7843 147.108C80.891 147.294 81.0312 147.437 81.2052 147.538C81.3791 147.639 81.5755 147.689 81.7944 147.689ZM88.2289 148.11V145.248H86.7475L86.7223 145.829C86.7111 146.07 86.697 146.3 86.6802 146.519C86.6634 146.738 86.6297 146.937 86.5792 147.117C86.5343 147.291 86.467 147.439 86.3772 147.563C86.2874 147.681 86.1668 147.762 86.0153 147.807L84.7191 147.622C84.8818 147.622 85.0137 147.574 85.1147 147.479C85.2157 147.378 85.2942 147.24 85.3503 147.066C85.4065 146.887 85.4485 146.685 85.4766 146.46C85.5047 146.23 85.5243 145.989 85.5355 145.736L85.5944 144.171H89.5419V148.11H88.2289ZM84.5676 149.676V147.622H90.19V149.676H88.9696V148.699H85.788V149.676H84.5676Z",
    fill: "white"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M186.343 148.699V142.807H189.087C189.772 142.807 190.305 142.939 190.686 143.203C191.068 143.467 191.259 143.843 191.259 144.331C191.259 144.813 191.079 145.189 190.72 145.459C190.361 145.722 189.884 145.854 189.289 145.854L189.449 145.501C190.111 145.501 190.624 145.633 190.989 145.896C191.354 146.16 191.536 146.542 191.536 147.041C191.536 147.557 191.34 147.964 190.947 148.262C190.56 148.553 189.993 148.699 189.247 148.699H186.343ZM187.698 147.689H189.196C189.511 147.689 189.749 147.627 189.912 147.504C190.075 147.381 190.156 147.19 190.156 146.932C190.156 146.685 190.075 146.502 189.912 146.385C189.749 146.261 189.511 146.199 189.196 146.199H187.698V147.689ZM187.698 145.248H188.969C189.267 145.248 189.491 145.189 189.642 145.072C189.794 144.948 189.87 144.769 189.87 144.533C189.87 144.297 189.794 144.12 189.642 144.003C189.491 143.879 189.267 143.817 188.969 143.817H187.698V145.248ZM197.177 148.699V144.171H198.481V148.699H197.177ZM194.896 145.619C195.49 145.624 195.936 145.759 196.234 146.023C196.537 146.281 196.688 146.648 196.688 147.125C196.688 147.625 196.517 148.015 196.175 148.295C195.833 148.57 195.347 148.708 194.719 148.708L192.514 148.699V144.171H193.818V145.619H194.896ZM194.601 147.773C194.854 147.779 195.047 147.726 195.182 147.613C195.316 147.501 195.384 147.333 195.384 147.108C195.384 146.884 195.316 146.724 195.182 146.629C195.047 146.528 194.854 146.474 194.601 146.469L193.818 146.46V147.773H194.601ZM199.141 148.699L201.169 146.039L201.144 146.763L199.2 144.171H200.673L201.902 145.863L201.346 145.88L202.617 144.171H204.014L202.061 146.738V146.031L204.082 148.699H202.592L201.304 146.898L201.851 146.974L200.572 148.699H199.141ZM206.709 148.767C206.227 148.767 205.797 148.666 205.421 148.464C205.051 148.262 204.756 147.987 204.538 147.639C204.324 147.285 204.218 146.884 204.218 146.435C204.218 145.981 204.324 145.579 204.538 145.231C204.756 144.878 205.051 144.603 205.421 144.407C205.797 144.205 206.227 144.104 206.709 144.104C207.186 144.104 207.613 144.205 207.989 144.407C208.365 144.603 208.659 144.875 208.872 145.223C209.086 145.571 209.192 145.975 209.192 146.435C209.192 146.884 209.086 147.285 208.872 147.639C208.659 147.987 208.365 148.262 207.989 148.464C207.613 148.666 207.186 148.767 206.709 148.767ZM206.709 147.689C206.928 147.689 207.124 147.639 207.298 147.538C207.472 147.437 207.61 147.294 207.711 147.108C207.812 146.918 207.862 146.693 207.862 146.435C207.862 146.171 207.812 145.947 207.711 145.762C207.61 145.577 207.472 145.433 207.298 145.332C207.124 145.231 206.928 145.181 206.709 145.181C206.49 145.181 206.294 145.231 206.12 145.332C205.946 145.433 205.806 145.577 205.699 145.762C205.598 145.947 205.548 146.171 205.548 146.435C205.548 146.693 205.598 146.918 205.699 147.108C205.806 147.294 205.946 147.437 206.12 147.538C206.294 147.639 206.49 147.689 206.709 147.689ZM213.144 148.11V145.248H211.662L211.637 145.829C211.626 146.07 211.612 146.3 211.595 146.519C211.578 146.738 211.545 146.937 211.494 147.117C211.449 147.291 211.382 147.439 211.292 147.563C211.202 147.681 211.082 147.762 210.93 147.807L209.634 147.622C209.797 147.622 209.929 147.574 210.03 147.479C210.131 147.378 210.209 147.24 210.265 147.066C210.321 146.887 210.363 146.685 210.391 146.46C210.419 146.23 210.439 145.989 210.45 145.736L210.509 144.171H214.457V148.11H213.144ZM209.482 149.676V147.622H215.105V149.676H213.884V148.699H210.703V149.676H209.482Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6004_59250",
    x1: 70.9084,
    y1: 155.269,
    x2: 81.1481,
    y2: 206.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D49973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#A26F4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#754A2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6004_59250",
    x1: 62.9658,
    y1: 151.456,
    x2: 62.9658,
    y2: 210.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#768E99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6004_59250",
    x1: 62.9658,
    y1: 151.456,
    x2: 62.9658,
    y2: 210.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#768E99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6004_59250",
    x1: 62.9658,
    y1: 151.456,
    x2: 62.9658,
    y2: 210.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#768E99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6004_59250",
    x1: 98.5829,
    y1: 210.722,
    x2: 98.5829,
    y2: 151.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#946A47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E2116"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6004_59250",
    x1: 98.5829,
    y1: 151.456,
    x2: 98.5829,
    y2: 210.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#768E99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6004_59250",
    x1: 98.5829,
    y1: 210.722,
    x2: 98.5829,
    y2: 151.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#946A47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E2116"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6004_59250",
    x1: 98.5829,
    y1: 151.456,
    x2: 98.5829,
    y2: 210.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#768E99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6004_59250",
    x1: 98.5829,
    y1: 210.722,
    x2: 98.5829,
    y2: 151.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#946A47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E2116"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6004_59250",
    x1: 98.5829,
    y1: 151.456,
    x2: 98.5829,
    y2: 210.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#768E99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6004_59250",
    x1: 206.25,
    y1: 158.57,
    x2: 206.25,
    y2: 172.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#768E99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6004_59250",
    x1: 206.25,
    y1: 174.35,
    x2: 206.25,
    y2: 188.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#768E99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6004_59250",
    x1: 206.25,
    y1: 190.502,
    x2: 206.25,
    y2: 199.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#946A47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E2116"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6004_59250",
    x1: 206.25,
    y1: 190.502,
    x2: 206.25,
    y2: 199.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#768E99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6004_59250",
    x1: 191.995,
    y1: 158.57,
    x2: 191.995,
    y2: 172.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#768E99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6004_59250",
    x1: 191.995,
    y1: 174.35,
    x2: 191.995,
    y2: 188.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#768E99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6004_59250",
    x1: 191.995,
    y1: 190.502,
    x2: 191.995,
    y2: 199.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#946A47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E2116"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_6004_59250",
    x1: 191.995,
    y1: 190.502,
    x2: 191.995,
    y2: 199.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#768E99"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetroEmpty);
export default __webpack_public_path__ + "static/media/MetroEmpty.f6d1eb66bbf43afd9c12.svg";
export { ForwardRef as ReactComponent };